import { render } from "./FavouriteCatalog.vue?vue&type=template&id=b13b57a0&ts=true&lang=pug"
import script from "./FavouriteCatalog.vue?vue&type=script&setup=true&lang=ts"
export * from "./FavouriteCatalog.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__